import { Injectable, Optional, SkipSelf } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StatusService {
  public forceLoader = false;
  public isLoading: boolean;
  public completionCount = 0;
  public completionCountPercentage = 0;
  public numberOfRequests = 0;
  public isSaving = false;

  constructor(@Optional() @SkipSelf() statusService?: StatusService) {
    this.isLoading = false;
  }

  public batchProgressSetup(requests: number): void {
    this.numberOfRequests = requests;
    this.completionCount = 0;
    this.completionCountPercentage = 0;
    this.isSaving = true;
  }

  public incrementCompletedRequests(): void {
    this.completionCount++;
    this.completionCountPercentage = (this.completionCount / this.numberOfRequests) * 100;
    if (this.completionCount === this.numberOfRequests) {
      this.isSaving = false;
    }
  }
}
